export const CONTACT = {
  phone: "813-330-0423",
  phoneHref: "tel:8133300423",
  email: "info@bblessedcc.com",
  address: "30740 State Road 54, Suite 112, Wesley Chapel, FL 33543",
  portal: "https://bblessedcc.clientsecure.me/sign-in",
  request: "https://bblessedcc.clientsecure.me",
  growTherapy: "https://growtherapy.com/book-appointment?id=40226&utm_source=provider-sourced&utm_medium=booking-link&utm_campaign=provider-dashboard",
  consultCopy: "Not sure where to start? Book a free 15-minute consultation.",
};

export const RESOURCES = {
  books: [
    {
      title: "God's Diamonds",
      author: "Tanya Richardson, LMHC",
      cover: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/sa4yatq6_Gods%20Diamond%203D%20%281%29.webp",
      description: "Diamonds are formed through pressure, chiseling, cutting, and polishing. Just like the diamond, your life and journey are all valuable to God—nothing is wasted. Dear Diamond, it's time for you to shine.",
      url: "https://www.amazon.com/dp/B081T9J6S1?_encoding=UTF8&psc=1&ref_=cm_sw_r_ffobk_cp_ud_dp_4JYH4PYP5Q4HVQ7ASAE6&bestFormat=true",
      cta: "Buy on Amazon",
    },
    {
      title: "All the King's Daughters",
      author: "Tanya Richardson, LMHC",
      cover: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/ft8j65sp_1000005941.jpg",
      description: "A rich, faith-forward reminder that every daughter of the King is chosen, loved, and equipped for her God-ordained purpose.",
      url: "https://www.amazon.com/dp/B07HY36KCW?ref_=cm_sw_r_ffobk_cp_ud_dp_939A1MSKAWM55FAX4R9B&bestFormat=true",
      cta: "Buy on Amazon",
    },
    {
      title: "The Marriage Purpose",
      author: "Tanya Richardson, LMHC",
      cover: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/b2f3yonm_1000005942.jpg",
      description: "Receiving your God-ordained spouse. Restoring marriage as a sacred, covenantal partnership—clinical wisdom woven with biblical truth.",
      url: "https://www.amazon.com/dp/B081V1ZDNS?_encoding=UTF8&psc=1&ref_=cm_sw_r_ffobk_cp_ud_dp_G5QY6TYNS53YDGZFS4KT&bestFormat=true",
      cta: "Buy on Amazon",
    },
  ],
  courses: [
    {
      title: "Schema Therapy",
      provider: "Udemy",
      cover: "https://img-c.udemycdn.com/course/750x422/1888612_20b8_5.jpg",
      description: "An accessible, clinician-informed introduction to Schema Therapy—understand the emotional patterns that shape everything.",
      url: "https://www.udemy.com/course/schema-therapy/?couponCode=CP260817G1",
      cta: "Enroll on Udemy",
    },
  ],
};

export const IMAGES = {
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_317e197a-ac38-4cb8-ad5f-25cc4e094791/artifacts/vu2opbv5_BBCC%20Colorful%20Transparent.png",
  tanya: "https://customer-assets-gfyr7b9c.emergentagent.net/job_317e197a-ac38-4cb8-ad5f-25cc4e094791/artifacts/l6wnubav_LR%20Bio%20Pic.webp",
  tanyaAlt: "https://customer-assets-gfyr7b9c.emergentagent.net/job_317e197a-ac38-4cb8-ad5f-25cc4e094791/artifacts/ygj4f8az_instagram_square.jpg",
  adrianne: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/763g265k_Adrianne%20Headshot.png",
  retreatHero: "https://images.pexels.com/photos/36646802/pexels-photo-36646802.jpeg",
  ocean: "https://images.unsplash.com/photo-1615472768508-9db82090f4c6",
  groups: "https://images.pexels.com/photos/3811108/pexels-photo-3811108.jpeg",
};

export const SERVICES = [
  { title: "Trauma & Inner Child Healing", desc: "Gentle, evidence-based work to heal old wounds and restore safety within.", span: true },
  { title: "Individual Counseling", desc: "One-on-one support for anxiety, depression, and life transitions." },
  { title: "Couples & Marriage", desc: "Rebuild trust, communication, and connection—together." },
  { title: "Christian Counseling", desc: "Faith-integrated care with scripture and prayer, upon request." },
  { title: "Group Therapy", desc: "Community healing for shared journeys and lasting connection." },
  { title: "Abuse & Codependency Recovery", desc: "Reclaim your voice, worth, and God-given dignity." },
];

export const APPROACHES = [
  "Cognitive Behavioral (CBT)", "Schema Therapy", "Attachment-Based", "Somatic Experiencing",
  "Solution-Focused (SFBT)", "Motivational Interviewing", "Gottman Method", "Mindfulness",
  "Emotionally Focused", "Christian Counseling",
];

export const TESTIMONIALS = [
  { quote: "If you are looking for a sign to book with Tanya—THIS IS IT! She is so good at framing things & helping you see clearly while working through them.", who: "Verified client, age 25–34" },
  { quote: "Tanya is warm, compassionate, and welcoming. I appreciate her authenticity. She offers a faith-based approach and valuable perspective on reframing challenges.", who: "Verified client, age 35–44" },
  { quote: "A safe, nonjudgmental space where healing unfolds at your own pace. I finally feel seen and heard.", who: "Verified client, age 30–39" },
];

export const TEAM = [
  {
    name: "Tanya Richardson",
    credentials: "LMHC — Licensed Mental Health Counselor",
    role: "Founder & Lead Psychotherapist",
    image: IMAGES.tanya,
    imageAlt: IMAGES.tanyaAlt,
    bio: "Tanya is a warm, intuitive, and deeply present therapist who helps individuals heal after life's most upsetting events. Her client-centered, integrative approach draws from CBT, Schema Therapy, Somatic Experiencing, Mindfulness, and Christian counseling upon request. She specializes in trauma recovery, anxiety, and helping women move from survival to peace.",
    tags: ["Trauma Recovery", "Christian Counseling", "Schema Therapy", "Anxiety"],
  },
  {
    name: "Adrianne",
    credentials: "Master's Level Clinician / Registered Mental Health Counselor Intern",
    role: "Associate Clinician",
    image: IMAGES.adrianne,
    bio: "Compassionate, insightful, and outcome-focused, Adrianne helps clients move forward with clarity, confidence, and purpose. Her warm, collaborative style uncovers unhelpful patterns, strengthens coping tools, and builds a path toward the life you truly want. She works with anxiety, relationship challenges, life transitions, trauma, and building self-worth.",
    tags: ["Anxiety & Stress", "Relationships", "Life Transitions", "Confidence Building"],
    accepting: false,
    full: true,
  },
];

export const GROUPS = [
  { id: "heal_your_inner_child", title: "Heal Your Inner Child", schedule: "Bi-weekly · Mondays 5:45 PM", desc: "Gentle guided work to reparent the younger parts of you—release old wounds and welcome her home." },
  { id: "anxiety_overthinking", title: "Anxiety & Overthinking", schedule: "Bi-weekly · Tuesdays 6:15 PM", desc: "Tools to calm the mind, regulate emotions, and build lasting resilience." },
  { id: "healing_after_abuse", title: "Abuse Recovery", schedule: "Bi-weekly · Wednesdays 6:15 PM", desc: "A safe circle for women recovering from emotionally abusive, narcissistic, or toxic relationships." },
  { id: "codependency_boundaries", title: "Codependency & Boundaries", schedule: "Bi-weekly · Thursdays 6:00 PM", desc: "Learn faith-based boundaries and heal people-pleasing patterns at the root." },
  { id: "grief_restoration", title: "Grief & Restoration", schedule: "Monthly · Saturdays 10:00 AM", desc: "Walk through loss with community, prayer, and compassionate support." },
  { id: "creative_coping_teens", title: "Creative Coping for Teens", schedule: "Bi-weekly · Saturdays 12:00 PM", desc: "A safe, creative circle where teens name big feelings and build healthy coping through art, journaling, and honest conversation." },
];

export const INSURANCE_ACCEPTED = [
  "Aetna", "Cigna", "Oscar", "United Healthcare", "UMR", "Avmed", "First Health", "Self-Pay",
];

export const FEES = [
  { label: "Initial Intake", price: "$125 – $150", note: "First session — comprehensive assessment" },
  { label: "60-minute Session", price: "$100 – $125", note: "Individual therapy" },
  { label: "45-minute Session", price: "$75 – $100", note: "Focused check-in" },
  { label: "Couples Session", price: "$150 – $175", note: "For couples & marital therapy" },
];

export const RETREAT_GALLERY = [
  { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/tob0xjgc_pexels-pnw-prod-9353606.webp", caption: "Barefoot, side by side" },
  { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/rp1rps7z_pexels-enrico-martins-1401051-7954570.webp", caption: "Daughters of the King" },
  { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/nh7ji4zt_pexels-rdne-8760441.webp", caption: "Joy shared, joy multiplied" },
  { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/jsf9bcw5_pexels-victoria-ofere-2149128219-32286796.webp", caption: "Held by Him, held by each other" },
  { url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_wellness-team-2/artifacts/i38o7qg5_pexels-elletakesphotos-1474273.webp", caption: "Steady presence, sacred rest" },
];

export const RETREAT = {
  name: "Renewed & Restored",
  subtitle: "A Christian Women's Therapy Intensive Retreat",
  tagline: "Heal. Grow. Connect. Be Renewed.",
  scripture: '"He restores my soul." — Psalm 23:3',
  dates: "May 14 – 17, 2027",
  location: "Clearwater, FL — Hotel Conference Room Near Beachfront",
  intro: "Step away from the noise and into a sacred space of healing, transformation, and sisterhood. This 4-day intensive retreat is designed to help you renew your mind, heal your heart, and deepen your walk with God.",
  pillars: [
    { title: "Faith-Filled Teaching", desc: "Biblically grounded and clinically informed therapy sessions." },
    { title: "Sisterhood & Community", desc: "Connect with women who uplift, encourage, and pray with you." },
    { title: "Healing & Transformation", desc: "Inner child healing, schema work, and renewing your identity in Christ." },
    { title: "Rest & Renewal", desc: "Intentional time for rest, prayer, and personal growth." },
  ],
  includes: ["Comfortable lodging (Villa & Hotel)", "All meals & snacks", "Parking included", "Goodie bag & retreat materials", "Prayer, fellowship & personal growth"],
  itinerary: [
    { day: "Friday, May 14", items: [
      ["12:00 PM", "Check-in & welcome"],
      ["12:30 PM", "Meet, prayer, sanctuary, safe place & lunch"],
      ["1:00 PM", "Opening session · RIM Phase 1 Group"],
      ["2:00 PM", "RIM Phase 2 Group"],
      ["3:00 PM", "RIM Phase 3 Group"],
      ["4:00 PM", "Hotel / villa check-in"],
      ["5:30 PM", "Dinner on a boat"],
      ["6:15 PM", "Fellowship, free time or counselor check-ins (45 min each)"],
    ] },
    { day: "Saturday, May 15", items: [
      ["10:30 AM", "Morning prayer & brunch"],
      ["11:00 AM", "RIM Phase 4 Group"],
      ["12:00 PM", "Guided inner-child & schema therapy"],
      ["1:00 PM", "Communication & boundaries"],
      ["2:00 PM", "Fellowship, free time or 1:1 counselor check-ins (45 min each)"],
      ["3:00 PM", "Fellowship, free time or 1:1 counselor check-ins (45 min each)"],
      ["4:00 PM", "Fellowship, free time or 1:1 counselor check-ins (45 min each)"],
      ["5:00 PM", "Fellowship, free time or 1:1 counselor check-ins (45 min each)"],
      ["5:30 PM", "Dinner on a rooftop"],
      ["6:00 PM", "Fellowship, free time or counselor check-ins (45 min each)"],
      ["6:45 PM", "Fellowship, free time or counselor check-ins (45 min each)"],
      ["7:30 PM", "Fellowship, free time or counselor check-ins (45 min each)"],
    ] },
    { day: "Sunday, May 16", items: [
      ["10:00 AM", "Morning prayer & brunch"],
      ["10:45 AM", "Sunday worship together"],
      ["1:00 PM", "Coffee & snacks"],
      ["2:30 PM", "Identity · share your story testimony workshop"],
      ["4:30 PM", "Praise, worship & prayer"],
      ["5:30 PM", "Sunset walk & communion on the beach"],
      ["7:00 PM", "Farewell dinner on a boat"],
    ] },
    { day: "Monday, May 17", items: [
      ["10:00 AM", "Check-out"],
      ["11:00 AM", "Closing prayer & commissioning"],
      ["", "See you next year"],
    ] },
  ],
  plans: [
    { key: "retreat_full", label: "Pay in Full", price: "$1,500", sub: "One payment", featured: true },
    { key: "retreat_4x", label: "4 Payments", price: "$375", sub: "every 2 weeks" },
    { key: "retreat_8x", label: "8 Payments", price: "$187.50", sub: "every 2 weeks" },
    { key: "retreat_15x", label: "15 Payments", price: "$100", sub: "every 2 weeks" },
  ],
};

export const MANIFESTO = [
  { n: "01", title: "You are seen", body: "We create a safe, nonjudgmental space where you feel genuinely heard and supported as you heal." },
  { n: "02", title: "Care rooted in faith", body: "Compassion, clinical excellence, and Christ-centered truth—woven together for lasting change." },
  { n: "03", title: "Healing with purpose", body: "We help you break the patterns you're ready to leave behind and step into the life God intended." },
];
